const $             = require('jquery');
const _             = require('underscore');
const status        = require('../util/status');
const referenceTpl  = require('../template/reference_tpl');

const api = {};

let elem = $(`<div></div>`);
let metrics = {
  finished: false,
  scroll_id: null,
  promise: null,
  results: []
};

function infiniteScroll(handler) {
  const tresholdPercent = 90;
  const timer = setInterval(update, 1e3);

  elem.parent().on('scroll.infinite', _.debounce(update, 200));

  function update() {
    let parent = elem.parent();
    if (!parent.length) return;

    if (parent[0].scrollHeight > parent[0].offsetHeight) {
      clearInterval(timer);
    }
    if (elem.data('finished')) {
      parent.off('scroll.infinite');
      clearInterval(timer);
      return;
    }
    let topPercent = (parent[0].scrollTop + parent[0].offsetHeight) / parent[0].scrollHeight * 100;
    if (topPercent > tresholdPercent || topPercent >= 100) handler();
  }
}

function metricsParams(doi, scroll_id) {
  let params = { doi, scroll: 1, size: 30 };
  if (scroll_id) params.scroll_id = scroll_id;
  return params;
}

function render({ metadata, syncApi }) {
  renderMetrics();
  scrollMetrics().then(() => {
    if (metrics.finished) return;
    renderMetrics();
    infiniteScroll(() => {
      scrollMetrics().then(() => {
        renderMetrics();
      });
    });
  });
  status.on('online', () => {
    scrollMetrics().then(() => {
      renderMetrics();
    });
  });

  return elem;

  function scrollMetrics() {
    if (!status.onLine) return Promise.resolve();
    if (metrics.finished) return Promise.resolve();
    if (metrics.promise) return metrics.promise;
    const params = metricsParams(metadata.doi, metrics.scroll_id);
    return metrics.promise = syncApi.reader.metrics(params).then(data => {
      if (!data.results || !data.results.length) {
        metrics.finished = true;
      } else {
        metrics.results = metrics.results.concat(data.results);
        metrics.scroll_id = data.scroll_id;
      }
    }).catch(() => {
      metrics.finished = true;
    }).finally(() => {
      metrics.promise = null;
    });
  }

  function renderMetrics() {
    elem.empty();
    elem.data('finished', metrics.finished);
    let references = metrics.results.map(ref => {
      return Object.assign({}, ref, {
        article_url: ref.url,
        authors: ref.authors.map(author => author.short_name || author.name)
      });
    });
    elem.append(referenceTpl({ references, syncApi }, 'citing_article'));
    if (!metrics.finished) {
      elem.append(`
        <div class="loading-more">
          <div class="loader-inner ball-pulse">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      `);
    }
  }
}

api.render = _.memoize(render);

module.exports = api;
